// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_61cc05a7c9--wrapper--2Lw5Y","chart":"_61cc05a7c9--chart--tdecn"};